import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import * as React from "react";

import * as uuid from "uuid";
import { ShopPacksWrapped } from "./index";

interface IapSelectorProps {
    value: any;
    platform: string;
    label: string;

    onChange(event, item);
}

interface IapSelectorState {
    id: string;
}

export class IapSelector extends React.Component<IapSelectorProps, IapSelectorState> {
    state = {
        id: uuid.v4()
    };

    getOptionLabel = (option) => {
        if (typeof option === "string") {
            return option;
        }

        return option.productId;
    };

    render() {
        return <Autocomplete
            onChange={this.props.onChange}
            value={this.props.value}
            options={ShopPacksWrapped.iapsByPlatform(this.props.platform)}
            getOptionLabel={this.getOptionLabel}
            isOptionEqualToValue={(option, value) => option.productId === value}
            renderInput={(params) =>
                <TextField {...params} label={this.props.label} id={`iap_select_${this.state.id}`} size="small"/>}
        />;
    }
}
